<template>
  <div class="dolu_sv">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <template slot="header" class="clearfix">
            <el-row>
              <el-col :span="24">
                <span class="title"> VARIANT EXPLORER </span>
              </el-col>
              <el-divider  />

              <el-col :span="24">
                <ve_vars_cufi />
              </el-col>

              <el-col :span="24">
                <el-divider  />
              </el-col>

              <el-col :span="24">
                <ve_vars_table :rapp="rapp"> </ve_vars_table>
              </el-col>

              <el-col :span="24">
                <el-divider  />
              </el-col>

              <el-col :span="24">
                <ve_exams v-if="ve_id_var != null"> </ve_exams>
              </el-col>

            </el-row>
          </template>

        </el-card>
      </el-col>
    </el-row>

  </div>

</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';
  // import Button from 'src/components/UIComponents/Button';
  import Loading from 'src/components/Layout/LoadingMainPanel.vue';
  import ve_vars_cufi from 'src/components/Views/VE_Vars_Cufi.vue';
  // import cnvs_dufi from 'src/components/Views/Cnvs_dufi.vue';
  import ve_vars_table from 'src/components/Views/VE_Vars_Table.vue';
  import ve_exams from 'src/components/Views/VE_Exams.vue';
  // import cnvs_table from 'src/components/Views/Cnvs_table.vue';

  // import igv from 'igv';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import FileSaver from 'file-saver';
  import axios from 'axios';
  import VueUploadComponent from 'vue-upload-component';
  Vue.component('file-upload', VueUploadComponent);

  // Vue.use(GloVars);

  export default {
    name: 've_vars',
    props: {
      rapp: String,
    },
    components: {
      [ve_vars_table.name]: ve_vars_table,
      [ve_vars_cufi.name]: ve_vars_cufi,
      [ve_exams.name]: ve_exams,
    },


    data () {
      return {

      }
    },

    computed: {
      ...mapState({
        user: state => state.user,

        ve_vars: state => state.ve_vars,
        ve_id_var: state => state.ve_id_var,

      }),

      ...mapGetters({

      }),

    },


    methods: {
      ...mapMutations({
        m_vars_order: 'm_vars_order',
        m_rapp: 'm_rapp',
        m_ve_exams: 'm_ve_exams',

      }),


      ...mapActions({
        a_ve_vars: 'a_ve_vars',
        a_f_filters: 'a_f_filters'

      }),


      watch_rapp () {
        this.m_rapp(this.rapp);
        if (this.rapp === "varexp") {
          this.a_ve_vars();
        } else {
          this.m_ve_exams([]);
        }


      },

    },


    beforeMount () {
      this.a_f_filters();
    },


    created () {
    },


    watch: {
      rapp: {
        handler: 'watch_rapp',
        immediate: true
      },
    },

  }
</script>

<style scoped lang="scss">
.dolu_sv {
  padding-top: 100px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;

}


</style>
